import { API_ROUTE_ADMIN_NOTIFICATIONS_TIMELINE_PAGE } from '@/resources/api-routes'
import { get } from '@/util/auth'

const IS_NEW_BACKEND_API = true

export type AssetNotificationTimelineItem = {
  id: number
  timelineAt: string | Date
  recipientName: string | null
  recipientAddress: string
  recipientRole: string | null
  notificationType: string
  contentSubject: string | null
  contentText: string | null
  messagePreview: string | null
}

export type AssetNotificationTimelinePage = {
  items: AssetNotificationTimelineItem[]
  nextCursor: string | null
}

export type GetAssetNotificationTimelinePageParams = {
  assetId: number
  limit?: number
  cursor?: string | null
}

export const getAssetNotificationTimelinePage = async ({
  assetId,
  limit,
  cursor,
}: GetAssetNotificationTimelinePageParams) => {
  const searchParams = new URLSearchParams({
    entityNamespace: 'assets',
    entityType: 'asset',
    entityRef: String(assetId),
  })

  if (typeof limit === 'number') {
    searchParams.set('limit', String(limit))
  }

  if (cursor) {
    searchParams.set('cursor', cursor)
  }

  return get<AssetNotificationTimelinePage>(
    `${API_ROUTE_ADMIN_NOTIFICATIONS_TIMELINE_PAGE}?${searchParams.toString()}`,
    IS_NEW_BACKEND_API
  )
}
